import Vue from 'vue'
import Router from 'vue-router'

// 导入你的页面组件
import Home from '@/home/index.vue'
import Product from '@/product/index.vue'
import About from '@/about/index.vue'

// 注册路由插件
Vue.use(Router)

// 配置路由规则
export default new Router({
  // 使用 history 模式（可选，去掉 URL 中的 #）
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/product',
      name: 'Product',
      component: Product
    },
    {
      path: '/about',
      name: 'About',
      component: About
    }
  ]
})